var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("TableRow", {
    attrs: { cols: _vm.cols, columns: _vm.columns },
    scopedSlots: _vm._u([
      {
        key: "col1",
        fn: function () {
          return [
            _c("TableAvatar", {
              attrs: {
                primary: "",
                image: _vm.user.avatar,
                initial: _vm.user.given_name[0] + _vm.user.family_name[0],
                title: `${_vm.user.given_name} ${_vm.user.family_name}`,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "col2",
        fn: function () {
          return [
            _vm.userCompany
              ? _c(
                  "RouterLink",
                  {
                    attrs: {
                      to: {
                        name: _vm.routeNames.NETWORK_COMPANY,
                        params: { id: _vm.userCompany.id },
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "cursor-pointer text-primary-600 text-sm hover:text-primary-800",
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.userCompany.business_name) + " "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "col3",
        fn: function () {
          return [
            _c("TableBadge", {
              attrs: { badge: _vm.user.role, color: _vm.roleColor },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "action",
        fn: function () {
          return [
            _c(
              "ColorIconContainer",
              {
                staticClass: "ml-4 mt-0.5",
                attrs: { iconStyle: "" },
                on: { click: _vm.message },
              },
              [_c("ChatIcon", { staticClass: "h-8 w-8" })],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }